import {
  GET_TEAMS_SUCCESS,
  GET_MY_TEAMS_SUCCESS,
  ADD_TEAM_SUCCESS,
  UPDATE_TEAM_MEMBERS_SUCCESS,
  LOGOUT_COMPLETE,
} from '../../constants/actionTypes';
import { sortBy, map } from 'lodash';

const initialState = {
  lastUpdated: null,
  lastEdited: null,
  sortedIds: [],
  myTeamsSortedIds: [],
};

export const teamsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TEAMS_SUCCESS:
      return saveTeams(state, action);

    case GET_MY_TEAMS_SUCCESS:
      return saveMyTeams(state, action);

    case ADD_TEAM_SUCCESS:
    case UPDATE_TEAM_MEMBERS_SUCCESS:
      return updateLastEdited(state, action);

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

function saveTeams(state, action) {
  const {
    entities: { teams },
    receivedAt,
  } = action;

  const sortedEntities = sortBy(teams, ['name']);
  const sortedIds = map(sortedEntities, 'id');

  return {
    ...state,
    lastUpdated: receivedAt,
    sortedIds,
  };
}

function saveMyTeams(state, action) {
  const {
    entities: { teams },
    receivedAt,
  } = action;

  const sortedEntities = sortBy(teams, ['name']);
  const sortedIds = map(sortedEntities, 'id');

  return {
    ...state,
    lastUpdated: receivedAt,
    myTeamsSortedIds: sortedIds,
  };
}

function updateLastEdited(state, action) {
  const { receivedAt } = action;

  return {
    ...state,
    lastEdited: receivedAt,
  };
}
